module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Roman.e5d04ce1.ttf";